import { Nav } from "../components/Nav";
import { Footer } from "../components/Footer";
import { Marquee } from "../components/Marquee";
import { Hero } from "../sections/Hero";
import { Checklist } from "../sections/Checklist";
import { Areas } from "../sections/Areas";
import { Approach } from "../sections/Approach";
import { Doctor } from "../sections/Doctor";
import { HowItWorks } from "../sections/HowItWorks";
import { Pathways } from "../sections/Pathways";
import { DontPromise } from "../sections/DontPromise";
import { VirtualCare } from "../sections/VirtualCare";
import { ProfileCta } from "../sections/ProfileCta";
import { Journal } from "../sections/Journal";
import { Ethics } from "../sections/Ethics";
import { Faq } from "../sections/Faq";
import { FinalCta } from "../sections/FinalCta";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Checklist />
        <Areas />
        <Approach />
        <Doctor />
        <HowItWorks />
        <Pathways />
        <DontPromise />
        <VirtualCare />
        <ProfileCta />
        <Journal />
        <Ethics />
        <Faq />
        <FinalCta />
      </main>
      <Footer />
    </div>
  );
}
